import { FC, useMemo } from 'react'
import { Table, Image, Descriptions, Space, Button, Popconfirm } from 'antd'
import { FormOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons'
import type { StandardProduct } from '../../../services/standardProduct'
import { connect } from 'react-redux'

const cateTreeToMapsHandler = (categories, initival: Record<string, any> = {}) => {
  if(categories?.category) {
    const {displayTerm, parentId, term, id} = categories.category
    if(id) {
      initival[id] = {
        displayTerm, parentId, term, id
      }
    }
    if(Array.isArray(categories?.children)) {
        categories.children.forEach(cate => cateTreeToMapsHandler(cate, initival))
    }
    return initival
  }
}

const getCateTermHandler = (cateId, cateMaps, initival: any[] = []) => {
    const { displayTerm, parentId, term } = (cateMaps?.[cateId] || {})
    if(displayTerm || term) {
      initival.unshift(displayTerm || term)
    }
    if(parentId) {
      getCateTermHandler(parentId, cateMaps, initival)
    }
    return initival
}
interface ListProps {
  onClcikEditorButton: (info: StandardProduct) => void
  onDelete: (id: string) => void
  onRefresh: (id: string) => void
  onClickQuantityOfGoods: (id: string) => void
  dataSource: StandardProduct[]
  brandList: Record<string, any>
  categoryTree: any[]
  loading: boolean
  pagination: Record<string, any>
}

const List: FC<ListProps> = ({
  onClcikEditorButton,
  onDelete,
  onRefresh,
  onClickQuantityOfGoods,
  dataSource,
  brandList,
  categoryTree,
  loading,
  pagination
}) => {

  const categoriesIdMap = useMemo(() => {
    return cateTreeToMapsHandler(categoryTree)
  }, [categoryTree])

  const columns = [
    {
      dataIndex: 'images',
      width: 140,
      align: 'center',
      render: (images: StandardProduct['images']) => (
        <Image
          height={100}
          src={images?.[0]?.full?.url}
        />
      ),
    },
    {
      dataIndex: 'standardProdcutInfo',
      width: 400,
      render: (info: undefined, row: StandardProduct) => (
        <div>
          <Descriptions column={1}>
            <Descriptions.Item label="标品ID">{row.id}</Descriptions.Item>
            <Descriptions.Item label="类目">
              {row.categoryId}-{getCateTermHandler(row.categoryId, categoriesIdMap).join("-")}
            </Descriptions.Item>
            <Descriptions.Item label="市场价">{row.marketRMB} / {row.marketDollar}</Descriptions.Item>
          </Descriptions>
        </div>
      ),
    },
    {
      dataIndex: 'prodcutInfo',
      width: 320,
      render: (info: undefined, row: StandardProduct) => (
        <div>
          <Descriptions column={1}>
            <Descriptions.Item label="品牌">
              { brandList?.[row.brandId]?.name || row.brandId }
            </Descriptions.Item>
            <Descriptions.Item label="英文名">{row.name}</Descriptions.Item>
            <Descriptions.Item label="中文名">{row.nameCN}</Descriptions.Item>
          </Descriptions>
        </div>
      ),
    },
    {
      dataIndex: 'info',
      width: 160,
      render: (info: undefined, row: StandardProduct) => (
        <div>
          <Descriptions column={1}>
            <Descriptions.Item label="关联商品数">
              <Button type="link" size="small" onClick={() => onClickQuantityOfGoods(row.id)}>
                {row.totalProduct}
              </Button>
            </Descriptions.Item>
            <Descriptions.Item label="图像识别阀值">{row.imageScore}</Descriptions.Item>
            <Descriptions.Item label="在线商品数">{row.availableProduct}</Descriptions.Item>
          </Descriptions>
        </div>
      ),
    },
    {
      dataIndex: 'action',
      width: 140,
      align: 'center',
      fixed: 'right',
      render: (action, row: StandardProduct) => (
        <Space direction="vertical" size={30}>
          <Button
            type="primary"
            size="middle"
            icon={<FormOutlined />}
            onClick={() => onClcikEditorButton(row)}
          >
            编辑
          </Button>
          <Popconfirm
            title={'确认删除?'}
            onConfirm={() => onDelete(row.id)}
            okText="确认"
            cancelText="取消"
          >
            <Button type="primary" size="middle" danger icon={<DeleteOutlined />}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
    {
      dataIndex: 'id',
      width: 140,
      align: 'center',
      fixed: 'right',
      render: id => (
        <Button
          type="primary"
          size="middle"
          icon={<ReloadOutlined />}
          onClick={() => onRefresh(id)}
        >
          刷新
        </Button>
      ),
    },
  ]

  return (
    <Table
      bordered
      columns={columns as any}
      showHeader={false}
      dataSource={dataSource}
      scroll={{ x: 1400 }}
      loading={loading}
      rowKey="id"
      pagination={pagination}
    />
  )
}

const mapStateToProps = (store) => {
    return {
        brandList: store.brands.brandList,
        categoryTree: store.categories.categoryTree
    };
}

export default connect(mapStateToProps)(List)

